var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9179 18.8585L18.6679 30.0005L7.41793 18.8585C6.67589 18.1364 6.0914 17.2685 5.70125 16.3095C5.31111 15.3504 5.12377 14.3209 5.15104 13.2859C5.1783 12.2509 5.41958 11.2327 5.85967 10.2955C6.29976 9.35832 6.92914 8.52239 7.70816 7.84038C8.48719 7.15837 9.39899 6.64504 10.3861 6.33273C11.3733 6.02042 12.4144 5.91589 13.444 6.02571C14.4735 6.13554 15.4692 6.45734 16.3682 6.97087C17.2673 7.48439 18.0503 8.17851 18.6679 9.00951C19.2882 8.18454 20.0721 7.49649 20.9706 6.98842C21.869 6.48034 22.8627 6.16318 23.8893 6.05679C24.916 5.9504 25.9536 6.05706 26.9371 6.3701C27.9206 6.68314 28.829 7.19582 29.6053 7.87605C30.3815 8.55629 31.0091 9.38944 31.4486 10.3233C31.8881 11.2573 32.13 12.2718 32.1594 13.3036C32.1887 14.3353 32.0048 15.362 31.6191 16.3194C31.2334 17.2768 30.6543 18.1442 29.9179 18.8675M18.6679 9.00043L13.7284 13.9399C13.4472 14.2212 13.2893 14.6027 13.2893 15.0004C13.2893 15.3982 13.4472 15.7796 13.7284 16.0609L14.5429 16.8754C15.5779 17.9104 17.2579 17.9104 18.2929 16.8754L19.7929 15.3754C20.6881 14.4803 21.9021 13.9775 23.1679 13.9775C24.4338 13.9775 25.6478 14.4803 26.5429 15.3754L29.9179 18.7504M19.4179 23.2504L22.4179 26.2504M23.1679 19.5004L26.1679 22.5004",
    stroke: "#DE1F4C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHandshake);
export default __webpack_public_path__ + "static/media/heart-handshake.507b7a37698170a617f1a623f503da11.svg";
export { ForwardRef as ReactComponent };